import React from "react";
import { useController } from "react-hook-form";
import { whenToBuyOptions } from "../../constants";
import './WhenToBuyV2.scss';

const WhenToBuyV2 = ({optionSelected, control, name})=>{
    const {
            field: { ref, ...inputProps }
        } = useController({
            name,
            control,
            rules: { required: true },
            defaultValue: null,
        });
    
    return (
        <div className="when-to-buy-container-v2 ">
            <div className="when-to-buy-label " >When do you plan to buy this car?</div>
            <div >
                <ul className="when-to-buy-option-list">
                    { whenToBuyOptions.map((option, index ) => {
                        return  (
                            <li className="when-to-buy-option" key={index}>
                                <input {...inputProps} inputRef={ref} id={option.id} type="radio"  value={option.value} style={{ display: "none" }} change={(e)=>{
                                    optionSelected(e);
                                }}></input>
                                <label htmlFor={option.id}>
                                    <div className="radio-circle"></div>
                                    <div>{option.label}</div>
                                </label>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    )
}

export default WhenToBuyV2;